import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import {
  House, BookOpen, Certificate, Receipt, Buildings,
  ChalkboardTeacher, SignOut, ShieldCheck,
} from "@phosphor-icons/react";
import { Logo } from "@/components/Logo";

const menus = {
  student: [
    { to: "/dashboard", label: "Resumen", icon: House },
    { to: "/dashboard/cursos", label: "Mis Cursos", icon: BookOpen },
    { to: "/dashboard/certificados", label: "Mis Certificados", icon: Certificate },
    { to: "/dashboard/compras", label: "Mis Compras", icon: Receipt },
  ],
  company: [
    { to: "/dashboard", label: "Panel Empresa", icon: Buildings },
  ],
  instructor: [
    { to: "/dashboard", label: "Mis Cursos", icon: ChalkboardTeacher },
  ],
  admin: [
    { to: "/dashboard", label: "Administración", icon: ShieldCheck },
  ],
};

const roleLabels = { student: "Alumno", company: "Empresa", instructor: "Relator", admin: "Administrador" };

export default function DashboardLayout() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  if (!user) return null;
  const items = menus[user.role] || [];

  return (
    <div className="min-h-screen flex bg-background">
      <aside className="hidden lg:flex flex-col w-64 bg-[#1E293B] text-white fixed h-full">
        <Link to="/" className="flex items-center px-6 h-16 border-b border-white/10">
          <Logo variant="dark" className="h-7" />
        </Link>
        <div className="px-4 py-5 flex-1">
          <div className="px-2 mb-4">
            <p className="text-xs uppercase tracking-overline text-slate-500">{roleLabels[user.role]}</p>
            <p className="font-semibold text-sm truncate mt-1">{user.name}</p>
          </div>
          <nav className="space-y-1">
            {items.map((it) => {
              const active = location.pathname === it.to;
              const Icon = it.icon;
              return (
                <Link key={it.to} to={it.to} data-testid={`side-${it.label}`}
                  className={`flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium transition-transform hover:-translate-y-[1px] ${
                    active ? "bg-primary text-white" : "text-slate-300 hover:bg-white/5"}`}>
                  <Icon size={18} weight={active ? "fill" : "regular"} /> {it.label}
                </Link>
              );
            })}
          </nav>
        </div>
        <div className="p-4 border-t border-white/10 space-y-1">
          <Link to="/catalogo" className="flex items-center gap-3 px-3 py-2.5 rounded-md text-sm text-slate-300 hover:bg-white/5">
            <BookOpen size={18} /> Ver catálogo
          </Link>
          <button onClick={() => { logout(); navigate("/"); }} data-testid="side-logout"
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-md text-sm text-slate-300 hover:bg-white/5">
            <SignOut size={18} /> Cerrar sesión
          </button>
        </div>
      </aside>

      <div className="flex-1 lg:ml-64">
        <header className="lg:hidden sticky top-0 z-40 bg-[#1E293B] text-white h-14 flex items-center justify-between px-4">
          <Link to="/"><Logo variant="dark" className="h-6" /></Link>
          <button onClick={() => { logout(); navigate("/"); }}><SignOut size={20} /></button>
        </header>
        <div className="lg:hidden flex gap-1 overflow-x-auto p-2 bg-white border-b border-border">
          {items.map((it) => (
            <Link key={it.to} to={it.to}
              className={`whitespace-nowrap px-3 py-1.5 rounded-md text-xs font-medium ${
                location.pathname === it.to ? "bg-primary text-white" : "bg-secondary text-foreground"}`}>
              {it.label}
            </Link>
          ))}
        </div>
        <main className="p-4 sm:p-6 lg:p-8 max-w-7xl mx-auto"><Outlet /></main>
      </div>
    </div>
  );
}
